import { useMapInstance } from './hooks/useMapInstance.web'
import { useOnDidFinishLoadingMap } from './hooks/useOnDidFinishLoadingMap.web'
import { useOrdersLayer } from './parts/OrdersLayer/useOrdersLayer.web'
import { useVenueLayer } from './parts/VenueLayer/useVenueLayer.web'
import { MapProps } from './types'
import { getInitialMapCenter } from '@/features/orders/components/MapPanel/parts/Content/utils/getInitialMapCenter'
import 'mapbox-gl/dist/mapbox-gl.css'
import { CSSProperties, memo, useRef } from 'react'
import { useTranslation } from 'react-i18next'

const Map = ({ venue, orders, language, paused, onOrderPress, onLoad, onError }: MapProps) => {
    const { t } = useTranslation()
    const initialCenter = useRef(getInitialMapCenter(venue, orders))
    const { container, map } = useMapInstance({
        initialCenter: initialCenter.current,
        language,
        onError,
    })

    const venueLayerLoaded = useVenueLayer({ map, venue, paused, onError })
    const ordersLayerLoaded = useOrdersLayer({ map, orders, paused, onOrderPress, onError })
    useOnDidFinishLoadingMap(map, venueLayerLoaded && ordersLayerLoaded, onLoad)

    return <div ref={container} aria-label={t('ordersMap.title')} style={containerStyle} />
}

const containerStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    position: 'absolute',
}

export default memo(Map)
